import { use, useEffect, useState } from "react";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { nodalOfficersRoleList } from "../../config/roleConfig";
import { nodalOfficersTableColumns } from "../../config/tableColumns";
import Table from "../../components/common/Table/Table";
import Button from "../../components/common/Button";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/utils";
import api from "../../api/ApiService";
import Message from "../../components/common/Message";

const Officers = ({ roleIds, pageTitle, district = true }) => {
  const [nodalOfficers, setNodalOfficers] = useState([]);
  const navigate = useNavigate();
  const [apiMessage, setApiMessage] = useState(null);
  const [totalEntries, setTotalEntries] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (history.state?.usr?.message) {
      setApiMessage({
        type: "success",
        message: history.state.usr.message,
      });
      window.history.replaceState({}, document.title); // Clear the state after showing the message
    }
  }, []);

  const fetchNodalOfficers = async (page = 1, perPage = 20, search = "") => {
    try {
      const response = await api.get("/admin/userslist", {
        params: {
          perPage,
          page,
          search,
        },
      });
      if (response.data.data) {
        const data =
          response.data.data.filter((u) =>
            roleIds.includes(String(u.role_id))
          ) || [];

        // Format the API data to match column accessors
        const formatted = data.map((item, index) => ({
          sr_no: index + 1,
          name: item.name,
          district_name: item.district_name,
          username: item.username,
          email: item.email,
          mobile_number: item.mobile_number,
          role_name: nodalOfficersRoleList.find(
            (role) => role.value === String(item.role_id)
          )?.name,
          id: item.id,
          role_id: item.role_id,
          created_at: formatDate(item.created_at),
          address: item.address,
          caf_id: item.caf_id,
        }));

        setNodalOfficers(formatted);
        setTotalEntries(data.length);
      } else {
        setNodalOfficers([]);
        setTotalEntries(0);
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  useEffect(() => {
    fetchNodalOfficers(currentPage, rowsPerPage, searchQuery);
  }, [currentPage, rowsPerPage, searchQuery]);

  const handleEdit = (row) => {
    navigate("/admin/officers/edit", {
      state: { officerData: row, showDistrict: district },
    });
  };

  const handleChangePassword = (row) => {
    navigate("/admin/user/change-password", {
      state: { officerData: row, showDistrict: district },
    });
  };

  return (
    <DashboardLayout pageTitle={pageTitle} mainClass="p-6">
      <div className="flex justify-end mb-4">
        <Button
          className="bg-btn font-semibold py-2 px-4 rounded-md"
          onClick={() =>
            navigate("/admin/officers/add", {
              state: { showDistrict: district },
            })
          }
        >
          + Add Officer
        </Button>
      </div>
      {apiMessage && (
        <Message
          apiMessage={apiMessage}
          setApiMessage={setApiMessage}
        ></Message>
      )}
      <div className="flex items-center justify-between h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
          {pageTitle}
        </div>
      </div>
      <Table
        columns={nodalOfficersTableColumns(
          handleEdit,
          handleChangePassword,
          district
        )}
        data={nodalOfficers}
        totalEntries={totalEntries}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onPageChange={setCurrentPage}
        onRowsPerPageChange={setRowsPerPage}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        rowsPerPageOptions={[20, 30]}
      />
    </DashboardLayout>
  );
};

export default Officers;
